// FAZ-10 / K-21 + K-34 + K-39 — Component Studio atomik blok kayıt defteri (saf;
// Puck'a ve React'a bağımlı DEĞİL). BE `ComponentJsonValidator.cs` aynası:
// kapalı-küme blok tipleri + tip-başına alan sabitleri + slot alanları + enum/aralık
// sabitleri. Contract-test (K-38) bu sabitleri BE dosyalarına karşı kilitler.
//
// Bu modül hem Studio Puck config'i (K-26) hem sayfa render'ı tarafından tüketilir;
// bu yüzden yalnız tip/veri sabitleri içerir, hiçbir görsel/motor bağımlılığı taşımaz.

// K-39 — heading tag aralığı 2-4 → 1-6 (tag = SEO; görsel boyut stil panelinde fontSize).
export const HEADING_LEVELS = [1, 2, 3, 4, 5, 6] as const;
export type HeadingLevel = (typeof HEADING_LEVELS)[number];

export const BUTTON_VARIANTS = ['primary', 'secondary', 'outline'] as const;
export type ButtonVariant = (typeof BUTTON_VARIANTS)[number];

export const CONTAINER_ALIGNS = ['left', 'center', 'right'] as const;
export type ContainerAlign = (typeof CONTAINER_ALIGNS)[number];

export const CONTAINER_PADDINGS = ['none', 'small', 'medium', 'large'] as const;
export type ContainerPadding = (typeof CONTAINER_PADDINGS)[number];

export const GRID_MIN_COLS = 2;
export const GRID_MAX_COLS = 4;
/** Grid kolon slot anahtarları (BE sözleşmesi `col1..col4`). */
export const GRID_SLOT_KEYS = ['col1', 'col2', 'col3', 'col4'] as const;

export const SPACER_MIN = 1;
export const SPACER_MAX = 500;

// --- K-29 (FAZ-10.5) tasarım-token kümeleri (BE ComponentJsonValidator aynası) ---

/** Ortak metin hizalaması (heading + text bloklarında). */
export const BLOCK_ALIGNS = ['left', 'center', 'right'] as const;
export type BlockAlign = (typeof BLOCK_ALIGNS)[number];

export const HEADING_TONES = ['default', 'primary', 'muted'] as const;
export type HeadingTone = (typeof HEADING_TONES)[number];

export const IMAGE_WIDTHS = ['auto', 'full', 'half', 'third'] as const;
export type ImageWidth = (typeof IMAGE_WIDTHS)[number];

export const IMAGE_ROUNDED = ['none', 'small', 'large'] as const;
export type ImageRounded = (typeof IMAGE_ROUNDED)[number];

export const BUTTON_SIZES = ['small', 'medium', 'large'] as const;
export type ButtonSize = (typeof BUTTON_SIZES)[number];

export const CONTAINER_BACKGROUNDS = ['none', 'light', 'brand', 'dark'] as const;
export type ContainerBackground = (typeof CONTAINER_BACKGROUNDS)[number];

export const GRID_GAPS = ['none', 'small', 'medium', 'large'] as const;
export type GridGap = (typeof GRID_GAPS)[number];

// --- K-34 / K-39 (FAZ-10.6) yeni blok enum/aralık sabitleri (BE aynası) ---

export const ALERT_TONES = ['info', 'success', 'warning', 'error'] as const;
export type AlertTone = (typeof ALERT_TONES)[number];

export const BADGE_TONES = ['default', 'brand', 'success', 'warning'] as const;
export type BadgeTone = (typeof BADGE_TONES)[number];

export const ICON_TONES = ['default', 'brand', 'muted'] as const;
export type IconTone = (typeof ICON_TONES)[number];

export const ICON_MIN_SIZE = 16;
export const ICON_MAX_SIZE = 96;

export const SOCIAL_PLATFORMS = ['x', 'facebook', 'instagram', 'linkedin', 'youtube', 'whatsapp'] as const;
export type SocialPlatform = (typeof SOCIAL_PLATFORMS)[number];

export const SOCIAL_SIZES = ['small', 'medium', 'large'] as const;
export type SocialSize = (typeof SOCIAL_SIZES)[number];
export const SOCIAL_MAX_ITEMS = 8;

export const VIDEO_SOURCES = ['embed', 'file'] as const;
export type VideoSource = (typeof VIDEO_SOURCES)[number];

export const LIST_MAX_ITEMS = 20;
export const LIST_ITEM_MAX_LENGTH = 200;

export const MAP_MIN_LAT = -90;
export const MAP_MAX_LAT = 90;
export const MAP_MIN_LNG = -180;
export const MAP_MAX_LNG = 180;
export const MAP_MIN_ZOOM = 1;
export const MAP_MAX_ZOOM = 19;

// K-39 — curated lucide ikon adları (BE `ComponentIconNames.All` aynası, kapalı küme).
// `icon.name` + `button.icon` yalnız bu kümeden. Contract-test BE ile birebir kilitler.
export const ICON_NAMES = [
  'check', 'x', 'info', 'alert-circle', 'phone', 'mail', 'map-pin', 'calendar', 'clock', 'user',
  'users', 'home', 'building', 'credit-card', 'wallet', 'percent', 'trending-up', 'shield', 'lock',
  'star', 'heart', 'arrow-right', 'arrow-left', 'chevron-down', 'chevron-up', 'plus', 'minus', 'search',
  'download', 'upload', 'file-text', 'globe', 'smartphone', 'banknote', 'piggy-bank', 'hand-coins',
  'landmark', 'briefcase', 'chart-bar', 'gift', 'headset', 'message-circle', 'send', 'external-link',
  'refresh', 'settings', 'thumbs-up', 'award', 'target', 'zap', 'layers',
] as const;
export type IconName = (typeof ICON_NAMES)[number];

/** BE `MaxComponentStyleJsonLength` aynası — blok başı ileri stil (styleJson) cap'i. */
export const MAX_BLOCK_STYLE_JSON_LENGTH = 4096;

/** Tüm saklanabilir blok tipleri (legacyHtml dahil — legacy köprüsü, palette DIŞI). */
export const STUDIO_BLOCK_TYPES = [
  'heading',
  'text',
  'image',
  'button',
  'container',
  'grid',
  'spacer',
  'divider',
  'quote',
  'alert',
  'badge',
  'stat',
  'accordion',
  'list',
  'video',
  'icon',
  'socialLinks',
  'htmlEmbed',
  'formRef',
  'sliderRef',
  'mapRef',
  'legacyHtml',
] as const;

export type StudioBlockType = (typeof STUDIO_BLOCK_TYPES)[number];

/** Palette'te GÖRÜNEN 21 blok — legacyHtml burada YOK (K-20, salt-okunur köprü). */
export const PALETTE_BLOCK_TYPES = [
  'heading',
  'text',
  'image',
  'button',
  'container',
  'grid',
  'spacer',
  'divider',
  'quote',
  'alert',
  'badge',
  'stat',
  'accordion',
  'list',
  'video',
  'icon',
  'socialLinks',
  'htmlEmbed',
  'formRef',
  'sliderRef',
  'mapRef',
] as const;

/** Kategorili palet (K-39): Puck categories için blok grupları. */
export const PALETTE_CATEGORIES: Record<string, readonly StudioBlockType[]> = {
  layout: ['container', 'grid', 'spacer', 'divider'],
  content: ['heading', 'text', 'quote', 'alert', 'badge', 'stat', 'list', 'accordion', 'button'],
  media: ['image', 'video', 'icon', 'socialLinks'],
  embed: ['formRef', 'sliderRef', 'mapRef', 'htmlEmbed'],
};

export function isStudioBlockType(value: string): value is StudioBlockType {
  return (STUDIO_BLOCK_TYPES as readonly string[]).includes(value);
}

/** Blok tipi başına slot alan anahtarları (nested kompozisyon taşıyan alanlar). */
export const SLOT_FIELDS: Record<string, readonly string[]> = {
  container: ['children'],
  grid: GRID_SLOT_KEYS,
};

// --- Blok prop şekilleri (veri; slot'lar render-zamanı React node olur) ---

/** Tüm görünür bloklara ortak opsiyonel ileri-stil alanı (legacyHtml HARİÇ). */
export interface BlockStyleProps {
  /** BE-sözleşme yapılandırılmış stil (K-31/K-40); ≤4096 karakter. */
  styleJson?: string;
}

export interface HeadingBlockProps extends BlockStyleProps {
  text: string;
  level: HeadingLevel;
  tone?: HeadingTone;
  align?: BlockAlign;
}
export interface TextBlockProps extends BlockStyleProps {
  html: string;
  align?: BlockAlign;
}
export interface ImageBlockProps extends BlockStyleProps {
  src: string;
  alt?: string;
  width?: ImageWidth;
  rounded?: ImageRounded;
}
export interface ButtonBlockProps extends BlockStyleProps {
  label: string;
  href: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  icon?: IconName;
}
export interface ContainerBlockProps extends BlockStyleProps {
  align?: ContainerAlign;
  padding?: ContainerPadding;
  background?: ContainerBackground;
}
export interface GridBlockProps extends BlockStyleProps {
  columnCount: number;
  gap?: GridGap;
}
export interface SpacerBlockProps extends BlockStyleProps {
  height: number;
}
export type DividerBlockProps = BlockStyleProps;
export interface QuoteBlockProps extends BlockStyleProps {
  text: string;
  author?: string;
}
export interface AlertBlockProps extends BlockStyleProps {
  tone?: AlertTone;
  html: string;
}
export interface BadgeBlockProps extends BlockStyleProps {
  label: string;
  tone?: BadgeTone;
}
export interface StatBlockProps extends BlockStyleProps {
  value: string;
  label: string;
}
export interface AccordionBlockProps extends BlockStyleProps {
  title: string;
  html: string;
}
export interface ListBlockProps extends BlockStyleProps {
  items: string[];
  ordered?: boolean;
}
export interface VideoBlockProps extends BlockStyleProps {
  source: VideoSource;
  url: string;
}
export interface IconBlockProps extends BlockStyleProps {
  name: IconName;
  size?: number;
  tone?: IconTone;
}
export interface SocialLinkItem {
  platform: SocialPlatform;
  url: string;
}
export interface SocialLinksBlockProps extends BlockStyleProps {
  items: SocialLinkItem[];
  size?: SocialSize;
}
export interface HtmlEmbedBlockProps extends BlockStyleProps {
  html: string;
}
export interface FormRefBlockProps extends BlockStyleProps {
  formId: string;
}
export interface SliderRefBlockProps extends BlockStyleProps {
  sliderId: string;
}
export interface MapRefBlockProps extends BlockStyleProps {
  lat: number;
  lng: number;
  zoom: number;
}
export interface LegacyHtmlBlockProps {
  html: string;
}

/** Bir kolon sayısını geçerli [2,4] aralığına kıstırır. */
export function clampColumnCount(value: unknown): number {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) return GRID_MIN_COLS;
  return Math.min(GRID_MAX_COLS, Math.max(GRID_MIN_COLS, Math.round(n)));
}

/** Bir başlık seviyesini geçerli {1..6} kümesine düşürür. */
export function normalizeHeadingLevel(value: unknown): HeadingLevel {
  const n = typeof value === 'number' ? value : Number(value);
  return (HEADING_LEVELS as readonly number[]).includes(n) ? (n as HeadingLevel) : 2;
}

/** Bir yükseklik değerini [1,500] aralığına kıstırır. */
export function clampSpacerHeight(value: unknown): number {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) return SPACER_MIN;
  return Math.min(SPACER_MAX, Math.max(SPACER_MIN, Math.round(n)));
}

/** Bir zoom değerini Leaflet [1,19] aralığına kıstırır. */
export function clampMapZoom(value: unknown): number {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) return 13;
  return Math.min(MAP_MAX_ZOOM, Math.max(MAP_MIN_ZOOM, Math.round(n)));
}

/** Yeni eklenen bir bloğun mantıklı örnek varsayılanları (Puck defaultProps). */
export function defaultStudioBlockProps(type: StudioBlockType): Record<string, unknown> {
  switch (type) {
    case 'heading':
      return { text: 'Başlık', level: 2 };
    case 'text':
      return { html: '<p></p>' };
    case 'image':
      return { src: '', alt: '' };
    case 'button':
      // href '/' site-içi kök — isSafeUrl geçer, boş olmayan güvenli varsayılan.
      return { label: 'Buton', href: '/', variant: 'primary' };
    case 'container':
      return { children: [], align: 'left', padding: 'medium' };
    case 'grid':
      return { columnCount: 2, col1: [], col2: [], col3: [], col4: [] };
    case 'spacer':
      return { height: 24 };
    case 'divider':
      return {};
    case 'quote':
      return { text: 'Alıntı metni', author: '' };
    case 'alert':
      return { tone: 'info', html: '<p>Bilgilendirme metni</p>' };
    case 'badge':
      return { label: 'Rozet', tone: 'default' };
    case 'stat':
      return { value: '100+', label: 'Açıklama' };
    case 'accordion':
      return { title: 'Başlık', html: '<p>İçerik</p>' };
    case 'list':
      return { items: ['Madde 1', 'Madde 2'], ordered: false };
    case 'video':
      return { source: 'embed', url: '' };
    case 'icon':
      return { name: 'star', size: 32, tone: 'default' };
    case 'socialLinks':
      return { items: [], size: 'medium' };
    case 'htmlEmbed':
      return { html: '' };
    case 'formRef':
      return { formId: '' };
    case 'sliderRef':
      return { sliderId: '' };
    case 'mapRef':
      return { lat: 41.0082, lng: 28.9784, zoom: 13 };
    case 'legacyHtml':
      return { html: '' };
    default:
      return {};
  }
}
